/**
 *      Arquivo responsável por guardar todos os end-point que serão requisitados
 *          pelo módulo
 */

export default {
    getCandidate: { method: 'get', url: 'api/secure/candidate/{username}' },
    updatePassword: { method: 'put', url: 'api/secure/candidate/password' },
    putCandidate: { method: 'put', url: 'api/secure/candidate/{id}' }, 
}